module.exports = __webpack_public_path__ + "a8184bbb2289fa534300c6cd1033355e.svg";